import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { MachineType, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var MachineService = /** @class */ (function (_super) {
    tslib_1.__extends(MachineService, _super);
    function MachineService(http) {
        var _this = _super.call(this, http, MapperService.machineMap) || this;
        _this._endpoint = '/odata/Machines';
        _this.machineNameSuggest = function (searchTerm, fetchSize, skip, machineType) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                select: ['Id', 'Name'],
                orderBy: ['Name'],
                skip: skip,
                top: fetchSize,
                filter: {
                    'Name': {
                        contains: searchTerm,
                    },
                },
            };
            if (machineType != null) {
                queryOptions.filter['Type'] = MachineType[machineType];
            }
            return _this
                .get(queryOptions)
                .pipe(map(function (res) { return ({
                total: res.total,
                data: res.data.map(function (machine) { return ({
                    id: machine.id,
                    text: machine.name,
                }); }),
            }); }));
        };
        return _this;
    }
    MachineService.prototype.deleteBulk = function (keys) {
        var payload = JSON.stringify({ 'machineIds': keys });
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.DeleteBulk", payload);
    };
    return MachineService;
}(ODataService));
export { MachineService };
